<template>
	<div>
		<!-- This is the audio element, it's not visible -->
		<audio ref="player" class="w-full no-outline" preload="auto">
			<source :src="src" type="audio/mpeg">
			Your browser does not support the audio element.
		</audio>
		<slot
            :current-time-seconds="currentTimeSeconds"
            :current-time="currentTime"
            :time-remaining="timeRemaining"
            :duration="duration"
            :percentage="percentage"
            :muted="muted"
            :playing="playing"
            :paused="paused"
            :volume="volume"
            :speed="speed"
            :buffered="buffered"
            :waiting="waiting"
            :ended="ended"
            :play="play"
            :pause="pause"
            :toggle-play="togglePlay"
            :player="this.$refs.player"
        />
	</div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    props: {
        src: {
            required: true,
            type: String,
        },
        savePosition: {default: false},
        loadOn: {default: true},
    },
    // watch: {
    //     src() {
    //         this.$refs.player.load()
    //         this.load()
    //     }
    // },
    mounted() {
        this.load()
    },
    data() {
        return {
            currentTimeSeconds: 0,
            currentTime: 0,
            duration: 0,
            percentage: 0,
            muted: false,
            playing: false,
            paused: true,
            volume: 1,
            speed: Number(window.localStorage.getItem('playbackSpeed')) || 1,
            buffered: null,
            waiting: false,
            bufferLoop: null,
            startTimeApplied: false,
            ended: false,
            loaded: false,
        }
    },
    beforeUnmount() {
        clearInterval(this.bufferLoop)
    },
    methods: {
        async load() {
            let player = this.$refs.player
            player.oncanplay = () => {
                // this.$emit('ready')
                if (this.loaded) return
                this.loaded = true
                this.waiting = false
                this.duration = player.duration
                if (this.startTime && !this.startTimeApplied) {
                    player.currentTime = this.startTime
                    this.startTimeApplied = true
                } else {
                    let savedTime = localStorage.getItem(`src:${this.src}`)
                    if (savedTime && this.savePosition) player.currentTime = Number(savedTime)
                }
                player.playbackRate = this.speed
            }
            player.onpause = () => {
                this.playing = false
                this.paused = true
            }
            player.onplay = () => {
                this.playing = true
                this.paused = false
                this.ended = false
                // if (!app.issuedChromeWarning && app.iOSversion && app.iOSversion[0] >= 13 && !navigator.appVersion.includes('Version')) {
                //     app.issuedChromeWarning = true
                //     alert('Please use the Safari app to ensure your sermon does not pause when the app is closed.')
                // }
            }
            player.ontimeupdate = async () => {
                this.currentTimeSeconds = player.currentTime
                this.currentTime = this.convertTime(player.currentTime)
                this.percentage = (player.currentTime/player.duration)*100
                localStorage.setItem(`src:${this.src}`, player.currentTime.toFixed(0));
                if (this.ended) await player.play()
            }
            player.onvolumechange = () => {
                this.volume = player.volume
                this.muted = player.volume && !player.muted ? false : true
            }
            player.onratechange = () => {
                this.speed = player.playbackRate
                window.localStorage.setItem('playbackSpeed', player.playbackRate)
            }
            player.onwaiting = () => {
                this.waiting = true
            }
            // `waiting` was only ever cleared inside `oncanplay`, which returns
            // early on `if (this.loaded) return` — so it could be set true by a
            // mid-playback stall and never set back. Nothing rendered it before
            // this change, but the players now show a spinner in place of the
            // play/pause glyph while it is true, which would have stuck on for
            // the rest of the sermon after the first network hiccup.
            // `playing` fires exactly when the element resumes after buffering.
            player.onplaying = () => {
                this.waiting = false
            }
            player.onseeked = () => {
                this.waiting = false
            }
            player.onended = () => {
                this.ended = true
                this.$emit('ended')
            }
            // this.getHistory()
            this.loaded && player.load()
            this.getBuffer()
        },
        async play() { await this.$refs.player.play() },
        async pause() { await this.$refs.player.pause() },
        async togglePlay() {
            if (this.playing) await this.pause()
            else await this.play()
        },
        getBuffer() {
            this.bufferLoop = setInterval(() => {
                let player = this.$refs.player
                if (player) {
                    var buffered = player.buffered;
                    var loaded;
                    if (buffered.length) {
                        loaded = 100 * buffered.end(buffered.length-1) / player.duration;
                        this.buffered = loaded.toFixed(0);
                    }
                }
            }, 500);
        },
        convertTime(time) {
            var time = dayjs("2015-01-01").second(time).format('H:mm:ss');
            return Number(time.split(":")[0]) ? time : time.replace('0:', '')
        },
    },
    computed: {
        startTime() {
            return Number(this.$route.query.startTime) || 0
        },
        timeRemaining() {
            return this.convertTime((this.duration - this.currentTimeSeconds)/this.speed) || '00:00'
        }
    }
}
</script>
